<template>
    <div style="height: 100%; padding-bottom: 70px; padding-top: 15px;">
        <input ref="autocomplete" id="autocomplete" placeholder="Search Address" style="font-size: 1.5em; height: 2.5em; border-radius: 15px;" />
        <!--<div>{{ JSON.stringify([pois]) }}</div>-->
        <gmaps-map @mounted="ready" :options="mapOptions">
            <!--<gmaps-marker 
              :position="markerPos" 
              :options="markerOptions"
              @dragend="markerdrag"
            />-->
            <!--<template v-for="(routepoi, index) in technicianpois">
                <gmaps-marker v-if="(focusedpoi==null || focusedpoi.id != routepoi.id)"  :key="routepoi.id+'_route'"
                    :position="routepoi.info.coords" 
                    :options="{icon: markers.route}"    
                    :zIndex="4000"                   
                    :label="(index+1).toString()"
                    @click="focusAppointment(routepoi)"           
                />
                <gmaps-marker v-else-if="(focusedpoi!=null && focusedpoi.id == routepoi.id)" :key="routepoi.id+'_route2'"
                    :position="routepoi.info.coords" 
                    :options="{icon: markers.route_focused}"                               
                    :zIndex="9000"
                    :label="(index+1).toString()"
                    @click="focusAppointment(routepoi)"
                /> 
            </template>-->
            <template v-for="(poi, index) in pois">
                <gmaps-marker v-if="poi.route==true && (focusedpoi==null || focusedpoi.id != poi.id)"  :key="poi.randcode + '_' + index"
                    :position="poi.info.coords" 
                    :options="{icon: markers.route}"    
                    :zIndex="4000"                   
                    :label="(poi.orderno).toString()"
                    @click="focusAppointment(poi)"           
                />
                <gmaps-marker v-else-if="poi.route==true && (focusedpoi!=null && focusedpoi.id == poi.id)" :key="poi.randcode + '_' + index"
                    :position="poi.info.coords" 
                    :options="{icon: markers.route_focused}"                               
                    :zIndex="9000"
                    :label="(poi.orderno).toString()"
                    @click="focusAppointment(poi)"
                />
                <gmaps-marker v-if="poi.route==false && poi.startplace"  :key="'startplace_' + poi.randcode + '_' + index"
                    :position="poi.info.coords" 
                    :options="{icon: markers.start}" 
                    :zIndex="8000"        
                /> 
                <gmaps-marker v-else-if="poi.route==false && !poi.selected && (focusedpoi==null || focusedpoi.id != poi.id)"  :key="poi.randcode + '_' + index"
                    :position="poi.info.coords" 
                    :options="{icon: markers[poi.info.marker]}"                       
                    @click="focusAppointment(poi)"           
                />
                <gmaps-marker v-else-if="poi.route==false && !poi.selected && (focusedpoi!=null && focusedpoi.id == poi.id)" :key="poi.randcode + '_' + index"
                    :position="poi.info.coords" 
                    :options="{icon: markers[poi.info.marker + '_focused']}"                               
                    :zIndex="5000"
                    @click="focusAppointment(poi)"
                />                
                <gmaps-marker v-else-if="poi.route==false && poi.selected && (focusedpoi==null || focusedpoi.id != poi.id)"  :key="poi.randcode + '_' + index"
                    :position="poi.info.coords" 
                    :options="{icon: markers.selected}"   
                    :zIndex="3000"
                    @click="focusAppointment(poi)"           
                />
                <gmaps-marker v-else-if="poi.route==false && poi.selected && (focusedpoi!=null && focusedpoi.id == poi.id)"  :key="poi.randcode + '_' + index"
                    :position="poi.info.coords" 
                    :options="{icon: markers.selected_focused}" 
                    :zIndex="8000"  
                    @click="focusAppointment(poi)"           
                />  
        
            </template>            
        </gmaps-map>      
    </div>
</template>
<script>
import { gmaps, gmapsMap, gmapsMarker } from 'x5-gmaps';

const markerss = {
    normal: require("src/assets/images/marker_normal.svg"),
    normal_focused: require("src/assets/images/marker_normal_focused.svg"),
    selected: require("src/assets/images/marker_selected.svg"),
    selected_focused: require("src/assets/images/marker_selected_focused.svg"),
    route: require("src/assets/images/marker_route.svg"),
    route_focused: require("src/assets/images/marker_route_focused.svg"),
    start: require("src/assets/images/marker_start.svg"),
};

export default {
  components: { gmapsMap, gmapsMarker },

  props: {   
        pois: {
            type: Array,
            default: () => [],
        },
        // technicianpois: {
        //     type: Array,
        //     default: () => [],
        // },
        focusedpoi: {
            type: Object,
            default: null,
        },
        fullheight: {
            type: Boolean,
            default: () => false,
        },     
        pinCoords: {
            type: Object,
            default: () => ({
                lat: undefined,
                lng: undefined
            }),
        }
    },

  data: () => ({
    autocomplete: null,
    places: null,
    map: null,
    markerPos: {lat: 28, lng: 24}, //{ lat: (this.pinCoords && this.pinCoords.lat ? this.pinCoords.lat : 38), lng: (this.pinCoords && this.pinCoords.lng ? this.pinCoords.lng : 24) }, //, 
    resultInfo: null,
    markers: markerss,

    markerOptions: {      
      icon: require("src/assets/images/marker_normal.svg"),
      start: require("src/assets/images/marker_start.svg")
    },

    mapOptions: {
      center: { lat: 37.9833, lng: 23.7278 },  //37.983388802468056, 23.727867248733407
      zoom: 10,      
      language: "gr"
    }
  }),
  methods: {
    ready(map) {
      this.map = map
      gmaps().then((maps) => {
        this.places = new maps.places.PlacesService(map);
        this.autocomplete = new maps.places.Autocomplete(this.$refs.autocomplete);
        this.autocomplete.addListener('place_changed', this.searchResultSelected);

      })
    },
    searchResultSelected() {
        const place = this.autocomplete.getPlace()
        if (place.geometry) {
            this.map.panTo(place.geometry.location)
            this.markerPos = place.geometry.location
        }       
        let rslt = this.extractAddress(place);
        this.$emit('onresult', rslt); 
        this.resultInfo = rslt;
    },

    extractAddress(placeResult) {    
      let addressComponents = placeResult.address_components;
      let rslt = {};      
      if(placeResult.address_components) {
        rslt['streetaddress']= this.extractPropertyFromGeocodingResults(addressComponents, "route") + " " + this.extractPropertyFromGeocodingResults(addressComponents, "street_number");
        rslt['municipality']= this.extractPropertyFromGeocodingResults(addressComponents, "locality");
        rslt['postalcode']= this.extractPropertyFromGeocodingResults(addressComponents, "postal_code");
        rslt['prefecture']= this.extractPropertyFromGeocodingResults(addressComponents, "administrative_area_level_3");
        rslt['country']= this.extractPropertyFromGeocodingResults(addressComponents, "country");
      }            
      if(placeResult.geometry) {
        rslt['lat']= placeResult.geometry.location.lat();
        rslt['lng']= placeResult.geometry.location.lng();
      }            
      return rslt;      
    },

    extractPropertyFromGeocodingResults(address_components, propName, longname=false) {
      let element = address_components.find(c=>c.types.includes(propName));
      if(element) {
          if(longname) {
              return element.long_name;                    
          }
          else {
              return element.short_name;
          }                
      }
      return "";
    },

    markerdrag(coords) {      
      
      // let rslt = {};
      // rslt['lat'] = coords.latLng.lat;
      // rslt['lng'] = coords.latLng.lng;
      // this.$emit('onresult', rslt);
      this.$emit('onresult', {lat: coords.latLng.lat(), lng: coords.latLng.lng()});
    },

    focusAppointment(poi) {
        this.$emit('focusAppointment', poi);
    }
  },

  mounted() {
    if(this.pinCoords.lat && this.pinCoords.lng) {;
      //alert("ENTERED PINCOORDS: " + JSON.stringify(this.pinCoords))
      this.markerPos.lat = this.pinCoords.lat;
      this.markerPos.lng = this.pinCoords.lng;
      this.mapOptions.center.lat = this.pinCoords.lat;
      this.mapOptions.center.lng = this.pinCoords.lng;
    }
  }
}
</script>
<style scoped>
    #autocomplete {
        border: 3px solid gray;
        border-radius: 5px;
        font-size: 18px;
        height: 40px;
        left: 15%;
        padding: 0 10px;
        position: relative;
        clear: both;
        top: 0;
        width: 70%;
        z-index: 1;
        margin-bottom: 15px;
    }
</style>